import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const classroom: Platform = {
  id: 'classroom',
  name: 'Google Classroom',
  iconIndex: PlatformRegistry.classroom.index,
  color: PlatformRegistry.classroom.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://classroom.google.com/share', {
      url: content.url,
    });
  },
};

